// extracted by mini-css-extract-plugin
module.exports = {"arrow-left":"styles_arrow-left__GPV9j","arrow-right":"styles_arrow-right__1g3Bu"};